module.exports = __webpack_public_path__ + "img/1557149085.5890ee93.jpg";